import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import get from 'lodash/get';
import filter from 'lodash/filter';
import { MdFilterList, MdEdit, MdFileDownload } from 'react-icons/lib/md';

import { getSelectedCandidatesList } from '../../services/sessionTrackServices';
import { API_BASE_URL } from '../../styles/constant';
import AppShell from '../../components/AppShell';
import Auth from '../../components/Auth';
import Loader from '../../components/Loader';
import DataTable from '../../components/DataTable';
import ModalFilter from '../../components/ModalFilter';
import ModalForm from '../../components/ModalForm';
import AttendanceVisualization from './components/AttendanceVisualization';

const TOTAL_SITTINGS = 36;

const attendanceHeaders = [
  { value: 'fullName', label: 'Name' },
  { value: 'candidateID', label: 'JYP Candidate ID' },
  { value: 'jypCity', label: 'City' },
  { value: 'gender', label: 'Gender' },
  { value: 'category', label: 'Category' },
  { value: 'religion', label: 'Religion' },
  { value: 'education', label: 'Education' },
  { value: 'stream', label: 'Stream' },
  { value: 'governmentOrOpposition', label: 'Govt/Opposition' },
  { value: 'computedAttendance.MONSOON.DAY_1-SITTING_1', label: 'Day 1 (Sitting 1)' },
  { value: 'computedAttendance.MONSOON.DAY_1-SITTING_2', label: 'Day 1 (Sitting 2)' },
  { value: 'computedAttendance.MONSOON.DAY_1-SITTING_3', label: 'Day 1 (Sitting 3)' },
  { value: 'computedAttendance.MONSOON.DAY_2-SITTING_1', label: 'Day 2 (Sitting 4)' },
  { value: 'computedAttendance.MONSOON.DAY_2-SITTING_2', label: 'Day 2 (Sitting 5)' },
  { value: 'computedAttendance.MONSOON.DAY_2-SITTING_3', label: 'Day 2 (Sitting 6)' },
  { value: 'computedAttendance.MONSOON.DAY_3-SITTING_1', label: 'Day 3 (Sitting 7)' },
  { value: 'computedAttendance.MONSOON.DAY_3-SITTING_2', label: 'Day 3 (Sitting 8)' },
  { value: 'computedAttendance.MONSOON.DAY_3-SITTING_3', label: 'Day 3 (Sitting 9)' },
  { value: 'computedAttendance.MONSOON.DAY_4-SITTING_1', label: 'Day 4 (Sitting 10)' },
  { value: 'computedAttendance.MONSOON.DAY_4-SITTING_2', label: 'Day 4 (Sitting 11)' },
  { value: 'computedAttendance.MONSOON.DAY_4-SITTING_3', label: 'Day 4 (Sitting 12)' },
  { value: 'computedAttendance.MONSOON.cabinetMeeting', label: 'Cabinet Meeting 1 Attendance' },
  { value: 'computedAttendance.MONSOON.totalSession', label: 'Total Monsoon Session' },

  { value: 'computedAttendance.WINTER.DAY_1-SITTING_1', label: 'Day 5 (Sitting 13)' },
  { value: 'computedAttendance.WINTER.DAY_1-SITTING_2', label: 'Day 5 (Sitting 14)' },
  { value: 'computedAttendance.WINTER.DAY_1-SITTING_3', label: 'Day 5 (Sitting 15)' },
  { value: 'computedAttendance.WINTER.DAY_2-SITTING_1', label: 'Day 6 (Sitting 16)' },
  { value: 'computedAttendance.WINTER.DAY_2-SITTING_2', label: 'Day 6 (Sitting 17)' },
  { value: 'computedAttendance.WINTER.DAY_2-SITTING_3', label: 'Day 6 (Sitting 18)' },
  { value: 'computedAttendance.WINTER.DAY_3-SITTING_1', label: 'Day 7 (Sitting 19)' },
  { value: 'computedAttendance.WINTER.DAY_3-SITTING_2', label: 'Day 7 (Sitting 20)' },
  { value: 'computedAttendance.WINTER.DAY_3-SITTING_3', label: 'Day 7 (Sitting 21)' },
  { value: 'computedAttendance.WINTER.DAY_4-SITTING_1', label: 'Day 8 (Sitting 22)' },
  { value: 'computedAttendance.WINTER.DAY_4-SITTING_2', label: 'Day 8 (Sitting 23)' },
  { value: 'computedAttendance.WINTER.DAY_4-SITTING_3', label: 'Day 8 (Sitting 24)' },
  { value: 'computedAttendance.WINTER.cabinetMeeting', label: 'Cabinet Meeting 2 Attendance' },
  { value: 'computedAttendance.WINTER.totalSession', label: 'Total Winter Session' },
  { value: 'computedAttendance.WINTER.attendanceTillWinter', label: 'AttendanceTillWinter' },

  { value: 'computedAttendance.BUDGET.seminarAttendance', label: 'Budget Seminar Attendance' },
  { value: 'computedAttendance.BUDGET.DAY_1-SITTING_1', label: 'Day 9 (Sitting 25)' },
  { value: 'computedAttendance.BUDGET.DAY_1-SITTING_2', label: 'Day 9 (Sitting 26)' },
  { value: 'computedAttendance.BUDGET.DAY_1-SITTING_3', label: 'Day 9 (Sitting 27)' },
  { value: 'computedAttendance.BUDGET.DAY_2-SITTING_1', label: 'Day 10 (Sitting 28)' },
  { value: 'computedAttendance.BUDGET.DAY_2-SITTING_2', label: 'Day 10 (Sitting 29)' },
  { value: 'computedAttendance.BUDGET.DAY_2-SITTING_3', label: 'Day 10 (Sitting 30)' },
  { value: 'computedAttendance.BUDGET.DAY_3-SITTING_1', label: 'Day 11 (Sitting 31)' },
  { value: 'computedAttendance.BUDGET.DAY_3-SITTING_2', label: 'Day 11 (Sitting 32)' },
  { value: 'computedAttendance.BUDGET.DAY_3-SITTING_3', label: 'Day 11 (Sitting 33)' },
  { value: 'computedAttendance.BUDGET.DAY_4-SITTING_1', label: 'Day 12 (Sitting 34)' },
  { value: 'computedAttendance.BUDGET.DAY_4-SITTING_2', label: 'Day 12 (Sitting 35)' },
  { value: 'computedAttendance.BUDGET.DAY_4-SITTING_3', label: 'Day 12 (Sitting 36)' },
  { value: 'computedAttendance.BUDGET.totalSession', label: 'Total Budget Session' },
  { value: 'computedAttendance.BUDGET.totalAttendance', label: 'Total Attendance' },
  { value: 'computedAttendance.BUDGET.attendancePercentage', label: 'Attendance %' },
];

class AttendanceReport extends React.Component {
  static propTypes = {
    authenticatedUserInfo: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      dataLoaded: false,
      candidates: [],
      tabValue: 0,
      filterConfig: {},
    };

    this.dataTableRef = null;
  }

  componentDidMount() {
    this.unsubscribe = getSelectedCandidatesList((candidates) => {
      const locationBasedCandidates = this.getLocationBasedCandidates(
        candidates,
        this.props.authenticatedUserInfo.type === 'ADMIN'
          ? 'OVERALL'
          : this.props.authenticatedUserInfo.location,
      );
      const modifyList = this.getModifyCandidatesList(locationBasedCandidates);
      this.setState({ dataLoaded: true, candidates: modifyList });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  round2Decimal = value => Math.round(value * 100) / 100;

  getLocationBasedCandidates = (candidates, city) => {
    const locationBasedCandidates = filter(candidates, (candidateInfo) => {
      if (city === 'OVERALL') {
        return true;
      }
      return candidateInfo.jypCity === city;
    });

    return locationBasedCandidates;
  };

  getFilteredCandidatesList = () => {
    let filteredCandidates = this.state.candidates;
    const filterKeys = Object.keys(this.state.filterConfig);

    if (filterKeys.length > 0) {
      filteredCandidates = filter(this.state.candidates, candidateData => filterKeys
        .map((filterKey) => {
          const filterData = this.state.filterConfig[filterKey];
          if (filterData.lookupType === 'equal') {
            if (Array.isArray(filterData.value)) {
              return filterData.value.includes(get(candidateData, filterKey));
            }
            return get(candidateData, filterKey) === filterData.value;
          }
          if (filterData.lookupType === 'geq') {
            return get(candidateData, filterKey) >= filterData.value;
          }
          if (filterData.lookupType === 'leq') {
            return get(candidateData, filterKey) <= filterData.value;
          }
          return false;
        })
        .every(val => val));
    }

    return filteredCandidates;
  };

  getSessionSittingsAndTotal = (candidateInfo, session) => {
    const sittings = {};
    let total = 0;
    [...Array(4)].forEach((val, dayindex) => {
      [...Array(3)].forEach((_, sittingIndex) => {
        const value = get(
          candidateInfo,
          `attendance.${session}.DAY_${dayindex + 1}-SITTING_${sittingIndex + 1}`,
        )
          ? 1
          : 0;
        sittings[`DAY_${dayindex + 1}-SITTING_${sittingIndex + 1}`] = value;
        total += value;
      });
    });

    return { sittings, total };
  };

  getModifyCandidatesList = candidates => candidates.map((candidateData) => {
    const monsoonSittingsAndTotal = this.getSessionSittingsAndTotal(candidateData, 'MONSOON');
    const winterSittingsAndTotal = this.getSessionSittingsAndTotal(candidateData, 'WINTER');
    const budgetSittingsAndTotal = this.getSessionSittingsAndTotal(candidateData, 'BUDGET');

    return {
      ...candidateData,
      computedAttendance: {
        MONSOON: {
          ...monsoonSittingsAndTotal.sittings,
          cabinetMeeting: get(candidateData, 'attendance.MONSOON.cabinetMeeting') ? 1 : 0,
          totalSession: monsoonSittingsAndTotal.total.toString(),
        },
        WINTER: {
          ...winterSittingsAndTotal.sittings,
          cabinetMeeting: get(candidateData, 'attendance.WINTER.cabinetMeeting') ? 1 : 0,
          totalSession: winterSittingsAndTotal.total.toString(),
          attendanceTillWinter: monsoonSittingsAndTotal.total + winterSittingsAndTotal.total,
        },
        BUDGET: {
          ...budgetSittingsAndTotal.sittings,
          seminarAttendance: get(candidateData, 'attendance.BUDGET.seminarAttendance') ? 1 : 0,
          totalSession: budgetSittingsAndTotal.total.toString(),
          totalAttendance: (
            monsoonSittingsAndTotal.total
              + winterSittingsAndTotal.total
              + budgetSittingsAndTotal.total
          ).toString(),
          attendancePercentage: this.round2Decimal(
            ((monsoonSittingsAndTotal.total
                + winterSittingsAndTotal.total
                + budgetSittingsAndTotal.total)
                / TOTAL_SITTINGS)
                * 100,
          ),
        },
      },
    };
  });

  renderToolbars = (selectedRows) => {
    if (selectedRows.length === 0) {
      return (
        <ToolbarContainer>
          <ModalFilter
            apiEndpoint={`${API_BASE_URL}/filters/attendance/`}
            trigger={(
              <IconButton aria-label="Filter list">
                <MdFilterList />
              </IconButton>
)}
            tooltipTitle="Filter"
            onApply={(filterConfig) => {
              this.setState({ filterConfig });
            }}
            onClear={() => {
              this.setState({ filterConfig: {} });
            }}
            initialValues={this.state.filterConfig}
          />

          {this.props.authenticatedUserInfo.type === 'ADMIN' && (
            <Tooltip title="Download CSV">
              <IconButton
                aria-label="Download CSV"
                onClick={() => {
                  const filterConfigQueryString = JSON.stringify(this.state.filterConfig);
                  const downloadUrl = `${API_BASE_URL}/attendance/downloadCsv/?filters=${filterConfigQueryString}`;
                  window.open(downloadUrl, '_blank');
                }}
              >
                <MdFileDownload />
              </IconButton>
            </Tooltip>
          )}
        </ToolbarContainer>
      );
    }

    return (
      <ToolbarContainer>
        {selectedRows.length === 1 && (
          <ModalForm
            key="edit-attendance"
            tooltipTitle="Edit Attendance"
            trigger={(
              <IconButton aria-label="Edit Attendance">
                <MdEdit size={24} />
              </IconButton>
)}
            apiEndpoint={`https://us-central1-jyp-admin-saas.cloudfunctions.net/updateCandidate/attendance/${
              selectedRows[0]
            }`}
            method="put"
            onClose={() => {
              if (this.dataTableRef) {
                this.dataTableRef.resetSelectedRows();
              }
            }}
          />
        )}
      </ToolbarContainer>
    );
  };

  render() {
    return (
      <div>
        <AppShell>
          {!this.state.dataLoaded ? (
            <Loader />
          ) : (
            <div>
              <TabsContainer>
                <Tabs
                  value={this.state.tabValue}
                  onChange={(event, tabValue) => {
                    this.setState({ tabValue });
                  }}
                >
                  <Tab label="Report" />
                  <Tab label="Visualization" />
                </Tabs>
              </TabsContainer>

              {this.state.tabValue === 0 && (
                <DataTable
                  ref={(comp) => {
                    this.dataTableRef = comp;
                  }}
                  title="Attendance Report"
                  tableHeaders={attendanceHeaders}
                  tableData={this.getFilteredCandidatesList()}
                  renderToolbars={selectedRows => this.renderToolbars(selectedRows)}
                />
              )}
              {this.state.tabValue === 1 && <AttendanceVisualization />}
            </div>
          )}
        </AppShell>
      </div>
    );
  }
}

export default props => (
  <Auth>{({ authState }) => <AttendanceReport {...props} {...authState} />}</Auth>
);

const TabsContainer = styled(Paper).attrs({
  elevation: 4,
})`
  margin-bottom: 16px;

  && {
    background: ${props => props.theme.palette.primary.main};
  }

  & * {
    color: ${props => props.theme.palette.primary.contrastText} !important;
  }
`;

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: 10px !important;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/AttendanceReport/AttendanceReport.js